// Loads config.json from public at runtime
let configPromise = null;

export function getConfig() {
  if (!configPromise) {
    configPromise = fetch('/config.json')
      .then(res => {
        if (!res.ok) throw new Error('Failed to load config.json');
        return res.json();
      });
  }
  return configPromise;
} 